var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4066_4251)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4066_4251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.4953 13.4684C10.8523 13.4684 11.1104 13.4684 11.3704 13.4684C14.3137 13.4684 17.257 13.4664 20.2003 13.4684C21.5662 13.4684 22.0842 14.1515 21.7311 15.4637C20.4564 20.2188 16.2539 23.5398 11.3102 23.5185C5.36348 23.4914 1.11636 19.0073 0.542053 13.8767C-0.0497113 8.57588 3.5552 3.40858 8.72392 2.22996C9.8182 1.98031 10.4895 2.51833 10.4934 3.67371C10.5012 6.6096 10.4953 9.54548 10.4953 12.4814C10.4953 12.7678 10.4953 13.0542 10.4953 13.4684ZM9.17211 3.63888C5.09961 4.12271 1.59559 8.70362 1.82647 13.0832C2.08646 18.0357 6.05613 22.0341 10.8077 22.1289C15.5205 22.2238 20.0431 18.8253 20.3846 14.8734C20.1188 14.8734 19.8568 14.8734 19.5949 14.8734C16.7021 14.8734 13.8092 14.8754 10.9164 14.8734C9.65522 14.8734 9.17599 14.3915 9.17405 13.1278C9.17017 10.2422 9.17405 7.3547 9.17405 4.46913C9.17405 4.20786 9.17405 3.94853 9.17405 3.64081L9.17211 3.63888Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0689 6.26504C12.0689 4.67807 12.0631 3.09111 12.0709 1.50608C12.0748 0.726147 12.3677 0.455202 13.1205 0.482297C18.6754 0.689376 23.1572 5.04578 23.5045 10.575C23.5142 10.7434 23.5201 10.9117 23.5201 11.0801C23.5239 11.6743 23.2038 11.98 22.6295 11.98C19.3758 11.9878 16.124 11.9878 12.8702 11.98C12.2533 11.98 12.0573 11.5988 12.0631 11.0259C12.0786 9.43896 12.0689 7.852 12.0689 6.26697V6.26504ZM22.1561 10.5402C21.8127 5.71541 17.6509 2.03249 13.4368 1.96862V10.5402H22.1561Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4066_4251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4066_4251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.04,
    height: 23.04,
    fill: "white",
    transform: "translate(0.47998 0.480469)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.0956d65d8566c9d3fb859dfd12d66ce1.svg";
export { ForwardRef as ReactComponent };